import React, { useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import WorekrHeader from "../../worker-header/components/index";
import WorkerFooter from "../../worker-footer/components/index";
import { forgotPassword } from "../slice/workerAuthSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {

  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.workerAuth);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(forgotPassword(email));

    if (result.meta.requestStatus === "fulfilled") {
      const responseMessage = result.payload?.message;
      toast.success(responseMessage, {
        position: "top-right",
        autoClose: 4000,
        style: { fontSize: "0.85rem" },
      });
      navigate("/signin");
    } else {
      const errorMessage =
        result.payload?.data ||
        result.payload?.message ||
        "Something went wrong";

      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 3000,
        style: { fontSize: "0.85rem" },
      });
    };
  };
  return (
    <>
      <WorekrHeader />
      <main className="overflow-hidden">
        <section className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-4">
              <h3 className="text-center mb-4">Forgot Password</h3>

              <form onSubmit={handleSubmit}>
                <input
                  type="email"
                  className="form-control mb-3"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />

                <button className="btn btn-primary w-100 mb-4" disabled={loading}>
                  {loading ? "Please Wait..." : "Next"}
                </button>
              </form>

            </div>
          </div>
        </section>

        <WorkerFooter />
      </main>
    </>
  );
};

export default ForgotPassword;